import { combineReducers } from 'redux';

// import all default exports (reducers) from each sub modules
import installer from './installer';
import integrations from './integrations';

export default combineReducers({ installer, integrations });

//  export all named exports (actions & selectors) from each sub modules
export * from './installer';
export * from './integrations';
